import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FullServiceShop() {
  const services = ['Routine maintenance and inspections', 'Brake service and suspension repair', 'Electrical system repairs', 'AC repair and climate systems', 'Transmission and fuel system repairs', 'EV service and diagnostics'];
  return <section className="py-20 px-4 bg-white" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-65">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-66">
            A shop you can rely on long-term
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6 pl-[0px] pr-[0px]" data-id="element-67">
            One shop for everything your car needs.
          </h2>
          <div className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto space-y-4" data-id="element-68">
            <p className="pl-[23px] pr-[23px]" data-id="element-69">
              Lancer Service is a full-service auto repair shop for most makes
              and models 2007 and newer — including EVs.
            </p>
            <p className="pl-[26px] pr-[26px]" data-id="element-70">
              Whether it's routine maintenance, brake service, transmission
              repair, electrical systems, or AC, you don't need a different shop
              for different problems.
            </p>
            <p className="font-medium text-brand-dark pl-[41px] pr-[41px]" data-id="element-71">
              Many customers come to us for the first time, see the difference,
              and never go back to their old shop.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-brand-light rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-12" data-id="element-72">
          <p className="font-bold text-brand-dark text-xl mb-8 text-center" data-id="element-73">
            We provide:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-74">
            {services.map((service, index) => <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-75">
                <CheckIcon className="w-6 h-6 text-brand-accent flex-shrink-0" data-id="element-76" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-77">
                  {service}
                </span>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-78">
          <p className="text-2xl font-bold text-brand-dark" data-id="element-79">
            Our goal isn't just fixing today's issue. It's helping you keep your
            car — and your budget — in better shape long-term.
          </p>
        </motion.div>
      </div>
    </section>;
}